import { IsNotEmpty, IsOptional } from "class-validator";

export class AttributeOptionDto {
  @IsNotEmpty()
  value: string;

  @IsOptional()
  color?: string;
}
